import React from 'react'
import LiveSupportPanel from './LiveSupportPanel'
import widgetStyles from './assets/widget.module.scss'
import classNames from 'classnames'
import DrawerHeader from './DrawerHeader'

const LiveSupportDrawer = props => {

  return <div
    className={classNames({
      [widgetStyles['drawer']]: true,
      [widgetStyles['closed']]: !props.open
    })}>
    <DrawerHeader
      onMinimise={props.onMinimise}
      onClose={props.onClose}
    />
    <LiveSupportPanel/>
  </div>

}

export default LiveSupportDrawer
